/* tslint:disable */
/* eslint-disable */
export enum SurveyMembershipTypeEnum {
  MEMBERSHIP_YES = 'Membership_Yes',
  MEMBERSHIP_PREVIOUSLY = 'Membership_Previously',
  MEMBERSHIP_NO_BUT_CLOSE = 'Membership_NoButClose',
  MEMBERSHIP_NO = 'Membership_No'
}
